import { useEffect, useRef } from "react";

const products = [
  { label: "Prescription", icon: require("../../assets/Prescription.svg") },
  { label: "OTC Drugs", icon: require("../../assets/OTC Drugs.svg") },
  { label: "Personal care & hygiene", icon: require("../../assets/Personal care & hygiene.svg") },
  { label: "Feminine care", icon: require("../../assets/Feminine care.svg") },
  { label: "Baby care", icon: require("../../assets/Baby care.svg") },
  { label: "Wellness", icon: require("../../assets/Wellness.svg") },
  { label: "Sports nutrition", icon: require("../../assets/Sports nutrition.svg") },
  { label: "Surgical & disposables", icon: require("../../assets/Surgical & disposables.svg") },
  { label: "Medical devices", icon: require("../../assets/oximeter.svg") },
  { label: "And much, much more", icon: require("../../assets/And much, much more.svg") },
];

export default function ProductRange() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const items = ref.current?.querySelectorAll(".animate-on-view");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="products" data-testid="products-section" className="ez-section bg-white" ref={ref}>
      <div className="ez-container">
        <div className="animate-on-view text-center mb-16">
          <div className="inline-block text-ez-teal font-semibold font-caveat text-lg mb-3">
            What We Carry
          </div>
          <h2 className="font-outfit text-2xl md:text-3xl font-bold text-ez-text">
            Our <span className="text-ez-teal">Product Range</span>
          </h2>
          <p className="text-ez-muted mt-4 max-w-xl mx-auto font-jakarta">
            From everyday essentials to specialized medical supplies — we have everything you need under one roof.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {products.map((item, i) => (
            <div
              key={item.label}
              data-testid={`product-card-${i}`}
              className="animate-on-view group flex flex-col items-center text-center p-5 rounded-2xl hover:bg-teal-50 hover:shadow-md transition-all duration-300 cursor-default"
              style={{ transitionDelay: `${i * 0.05}s` }}
            >
              <div className="w-16 h-16 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <img
                  src={item.icon.default || item.icon}
                  alt={item.label}
                  className="h-12 w-12 object-contain"
                />
              </div>
              <p className="text-sm font-semibold text-ez-text font-outfit leading-tight">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
